module.exports = __webpack_public_path__ + "img/poster-custom.f79d1f94.jpg";